import React from 'react';
import { FmlaTypesComponent} from './FmlaTypesComponent';
import { httpServices } from '../../../services/httpServices';
import { ErrorPage } from '../../common/error';

const formFields = {
        'title' : null, 
        'description' : null,
        'fmla_status' : 1
    }
export class FmlaTypesContainer extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            formFields: formFields,
            errors: {},
            hasPermission : true,
            dataLoaded : false,
            showLoader : true,
            open : false,
            action : '',
            editId : 0,
            snackbarOpen : false,
            snackbarMsg : '',
            snackbarVariant : '',
            filterViewState : false,
            editPermission : false,
            nameFormat : 'FIRSTLAST',
            fmlaTypes : [],
        }
        this.onAddFmlaType = this.onAddFmlaType.bind(this);
        this.onEditFmlaType = this.onEditFmlaType.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.snackbarClose = this.snackbarClose.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
    }
    
    componentDidMount()
    {
        this.getFmlaTypesList();        
    }
    getFmlaTypesList = () => {
        let year = this.state.year;
        let apiEndpoint = 'api/settings/listFmlaTypes';
        return httpServices.post(apiEndpoint,{year : year})
            .then(response => {
                if(response.data.permission) {
                    this.setState({hasPermission : true,
                        fmlaTypes : response.data.fmla_types,
                        editPermission : response.data.edit_permission,
                        maxYear : response.data.max_year
                    });
                }
                else {
                    this.setState({hasPermission : false, 
                        editPermission : response.data.edit_permission
                    });
                }

            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    };


    onAddFmlaType = () => {
        this.setState({
            open: true,
            action : 'add'
        });
    }

    onEditFmlaType = (id) => {
        this.setState({
            open: true,
            action : 'edit',
            editId : id
        },function () {
            this.getUpdateData(id);
        });

    }

    getUpdateData = (id) => {
        let apiEndpoint = 'api/settings/listFmlaTypes';
        return httpServices.post(apiEndpoint,{id : id})
            .then(response => {
                if(response.data.permission) {
                    let formFields = this.state.formFields;
                    formFields.title = response.data.selected_data.title;
                    formFields.fmla_status= response.data.selected_data.status;
                    formFields.description = response.data.selected_data.description;
                    this.setState({hasPermission : true,
                        formFields : formFields,
                    });
                }
                else {
                    this.setState({hasPermission : false});
                }

            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    };

    onClose = () =>{
        let ff = this.state.formFields;
        ff['description'] = null;
        ff['title'] = null;
        ff['fmla_status'] = 1;
        this.setState({
            open: false,
            errors:{},
            deleteConfirm : false,
            formFields : ff 
        });
        this.clearForm();
    }

    clearForm = () => {
        let ff = this.state.formFields;
        ff['description'] = null;
        ff['title'] = null;
        ff['fmla_status'] = 1;
        this.setState({
            errors: {},
            errorMessage: false,
            formFields : {} 
        });
    };

    handleOnChange = (evt, value) => {
        const field = evt.target.name;
        const ff = this.state.formFields;
        console.log(field);
        console.log(evt.target.value);
        ff[field] = evt.target.value;
        this.setState({
            formFields: ff
        });
    }

    onSubmit = (id = null) => {
        if(this.handleValidation()) {
            this.onSave(id);
        }
    }

    onSave = (id) => {
        let formFields = this.state.formFields;
        console.log(formFields);
        let apiEndpoint = 'api/settings/saveFmlaType';
        return httpServices.post(apiEndpoint,{'id':id,'title':formFields.title,'description':formFields.description,'fmla_status':formFields.fmla_status == 0 ? '0': 1})
            .then(response => {
                if (response.data.permission) {
                    let message = '';
                    if (response.data.valid) {
                        if (id) {
                            message = 'FMLA type updated successfully';
                        }
                        else {
                            message = 'FMLA added successfully';
                        }
                        this.setState({
                            open : false,
                            hasPermission: true,
                            snackbarOpen: true,
                            snackbarMsg: message,
                            snackbarVariant: 'success',
                            fmlaTypes : response.data.fmla_types,
                        });
                        this.clearForm();
                    }
                    else {
                        if (response.data.errors) {
                            this.setState({ errors: response.data.errors });
                        }
                        else {
                            if (id) {
                                message = 'Update failed, FMLA Type already exist';
                            }
                            else {
                                message = 'Add failed, FMLA Type already exist';
                            }
                            this.setState({
                                hasPermission: true,
                                snackbarOpen: true,
                                snackbarMsg: message,
                                snackbarVariant: 'error'
                            });
                        }
                    }
                }
                else {
                    this.setState({ hasPermission: false });
                }

            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    }

    handleValidation() {
        let formIsValid = true;
        let errors = {};
        if (!this.state.formFields.title || this.state.formFields.title.trim() === '' ) {
            errors["title"] = "Cannot be empty";
            formIsValid = false;
        }
        if (!this.state.formFields.description || typeof this.state.formFields.description.trim() === '') {
            errors["description"] = "Cannot be empty";
            formIsValid = false;
        }
        if (this.state.formFields.fmla_status === -1) {
            errors["fmla_status"] = "Cannot be empty";
            formIsValid = false;
        }
        this.setState({errors: errors});
        return formIsValid;
    }

    snackbarClose = () => {
        this.setState({
            snackbarOpen : false,
        });
    }



    render(){
        return(
            (this.state.hasPermission)
            ?
            <FmlaTypesComponent
            FormFields = {this.state.formFields}
            AddFmlaType = {this.onAddFmlaType}
            Open = {this.state.open}
            Close = {this.onClose}
            Action = {this.state.action}
            OnSubmit = {this.onSubmit}
            HandleOnChange = {this.handleOnChange}
            Errors = {this.state.errors}
            EditFmlaType = {this.onEditFmlaType}
            EditId = {this.state.editId}
            SnackbarOpen = {this.state.snackbarOpen}
            SnackbarMsg = {this.state.snackbarMsg}
            SnackbarVariant = {this.state.snackbarVariant}
            SnackbarClose = {this.snackbarClose}
            EditPermission = {this.state.editPermission}
            NameFormat = {this.state.nameFormat}
            FmlaTypes = {this.state.fmlaTypes}
            />
            :
            <ErrorPage/>
        )
    }
}
